import { type ClassValue, clsx } from 'clsx'
import { parseISO } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function removeNonDigitsFromNumber(number: string) {
  return number.replace(/\D/g, '')
}

export const currencyFormatter = new Intl.NumberFormat('en-US', {
  currency: 'USD',
  style: 'currency',
})

export const DATE_FNS_DEFAULT_DATE_FORMAT = 'MM/dd/yyyy, h:mm aa'

export function formatDateToUsersTimezone(dateTimeStr: string) {
  // Parse the ISO string

  const dateUTC = dateTimeStr.replace(' ', 'T') + 'Z'

  const date = parseISO(dateUTC)

  // Get user's timezone
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  // Format the date in user's timezone
  return formatInTimeZone(date, userTimeZone, DATE_FNS_DEFAULT_DATE_FORMAT)
}

export function toUtcStartOfDayISOString(date?: Date) {
  if (!date) return undefined

  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    0,
    0,
    0,
    0
  ).toISOString()
}

export function toUtcEndOfDayISOString(date?: Date) {
  if (!date) return undefined

  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    23,
    59,
    59,
    999
  ).toISOString()
}
